import { useMemo } from 'react'
import { aiGeneratedNeedsReview } from '../utils'

export const useAiReviewNeeded = (itemGroups) => {
  return useMemo(() => aiGeneratedNeedsReview(itemGroups), [itemGroups])
}
